module.exports = __webpack_public_path__ + "static/media/19_avatar.9a79142a.png";